import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";

const Address = ({ data, setData }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isChangeOpen, setIsChangeOpen] = useState(false);
    const [newAddress, setNewAddress] = useState("");
    const [selectedAddressType, setSelectedAddressType] = useState("")
    const [city, setCity] = useState("")
    const [pincode, setPincode] = useState("")
    const [selectedAddress, setSelectedAddress] = useState({});
    const login = JSON.parse(localStorage.getItem("login")) || false;
    const [addressmain, setAddress] = useState([])
    const [load, setLoad] = useState(false);
    // Function to open modal
    const openModal = () => setIsModalOpen(true);
    const OpenChangeModal = () => setIsChangeOpen(true);

    // Function to close modal
    const closeModal = () => setIsModalOpen(false);
    const closeChangeModal = () => setIsChangeOpen(false);

    const handleAddressChange = (e) => {
        setNewAddress(e.target.value);
    };


    const handleChange = (e) => {
        const { name, value } = e.target;
        setData((prev) => ({
            ...prev,
            [name]: value,
        }));
    }

    const handleSubmit = async (e) => {
        setLoad(true);
        e.preventDefault();
        try {
            const response = await fetch(`https://100billionrealestate.com/user-address`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    location_user: data.location_user,
                    new_address: data.new_address,
                    city: data.city,
                    pincode: data.pincode,
                    user_id: login.emplyee_ID,
                    user_name: login.full_name,
                })
            });
            const result = await response.json();
            if (response.ok) {
                toast.success(result.message || "Address added successfully", {
                    position: "top-center",
                    autoClose: 2000, // Close toast after 3 seconds
                });
                console.log(result.message || "Address added successfully");
                setNewAddress(data.new_address); // Update the displayed address
                setIsModalOpen(false); // Close modal
                setLoad(false);
                fetchAddress(); // Fetch updated address list
            }
            else {
                toast.error(result.message || "Failed to add address", {
                    position: "top-center",
                    autoClose: 2000, // Close toast after 3 seconds
                });
                console.error(result.message || "Failed to add address");
                setLoad(false);
            }
        } catch (error) {
            toast.error("Error while adding address:", error, {
                position: "top-center",
                autoClose: 2000, // Close toast after 3 seconds
            });
            setLoad(false);
            console.error("Error while adding address:", error);
        }
    }

    const saveAddressChange = () => {
        setNewAddress(`${selectedAddress.new_address}, ${selectedAddress.city} - ${selectedAddress.pincode}`);
        setIsChangeOpen(false); // Close modal
    };

    const fetchAddress = async () => {
        try {
            const response = await fetch(`https://100billionrealestate.com/user-address/${login.emplyee_ID}`);
            const data = await response.json();

            const addresses = data.user;
            setAddress(addresses);
            console.log(addresses)

            if (addresses.length === 0) {
                // Find default address
                setSelectedAddress({});
                setNewAddress("");
            } else {
                // If no address found
                const defaultAddr = addresses.find(addr => addr.defaultaddress === "1" || addr.defaultaddress === 1);

                // Set default or fallback to first address
                const selected = defaultAddr || addresses[0];
                setSelectedAddress(selected);
                setNewAddress(`${selected.new_address}, ${selected.city} - ${selected.pincode}`);
            }
        } catch (error) {
            console.log("Error fetching address:", error);
            setSelectedAddress({});
            setNewAddress("");
        }
    };

    console.log(newAddress)



    // const addresses = [
    //     "A/204, Lotus Residency, Andheri West, Mumbai, Maharashtra - 400053",
    //     "B/102 SUNFLOWER APARTMENT, MIRA ROAD EAST, THANE - 401105",
    //     "C/205 GREEN VIEW RESIDENCY, BORIVALI WEST, MUMBAI - 400092",
    // ];
    console.log(selectedAddress)
    useEffect(() => {
        fetchAddress();
    }, [])

    return (
        <>
            <div className="address-card-section">
                <div className="address-card">
                    <h3>Billing Address</h3>
                    {selectedAddress && selectedAddress.new_address ? (
                        <>
                            <p className="address-type"><strong>{selectedAddress.location_user || "Home"}</strong></p>
                            <p className="address-details">
                                {`${selectedAddress.new_address}, ${selectedAddress.city} - ${selectedAddress.pincode}`}
                            </p>
                            {/* <p className="address-mobile"><strong>Mobile:</strong>9876543210</p> */}
                        </>
                    ) : (
                        <p className="no-address-text">No address selected</p>
                    )}


                    {/* <p className="address-mobile"><strong>Mobile:</strong>9876543210</p> */}
                    <div className="address-actions">
                        <button onClick={OpenChangeModal}>Change</button> | <button onClick={openModal}>Add Address</button>
                    </div>
                </div>
            </div>

            {isModalOpen && (
                <div className="address-overlay">
                    <div className="address-content">
                        <h3>Add Address</h3>
                        <form onSubmit={handleSubmit}>
                            <div className="add-new-address-type-perfume">
                                <div className="add-new-address-radio-group-perfume">
                                    <label
                                        className={data.location_user === "Home" ? "add-new-selected-perfume" : ""}
                                        onClick={handleChange}
                                    >
                                        Home
                                        <input type="radio" name="location_user" value="Home" checked={data.location_user === "Home"} readOnly />
                                    </label>

                                    <label
                                        className={data.location_user === "Office" ? "add-new-selected-perfume" : ""}
                                        onClick={handleChange}
                                    >
                                        Office
                                        <input type="radio" name="location_user" value="Office" checked={data.location_user === "Office"} readOnly />
                                    </label>

                                    <label
                                        className={data.location_user === "Others" ? "add-new-selected-perfume" : ""}
                                        onClick={handleChange}
                                    >
                                        Others
                                        <input type="radio" name="location_user" value="Others" checked={data.location_user === "Others"} readOnly />
                                    </label>
                                </div>
                            </div>
                            <div className="address-input-group">
                                <input
                                    type="text"
                                    name="new_address"
                                    className="address-input"
                                    placeholder="Enter new address"
                                    value={data.new_address}
                                    onChange={handleChange}
                                />
                                <div className="address-city-pincode">
                                    <input
                                        type="text"
                                        name="city"
                                        className="city-input"
                                        placeholder="Enter new city"
                                        value={data.city}
                                        onChange={handleChange}
                                    />
                                    <input
                                        type="text"
                                        className="pincode-input"
                                        name="pincode"
                                        placeholder="Enter new pincode"
                                        value={data.pincode}
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>

                            <div className="address-modal-actions">
                                <button onClick={closeModal} className="address-close">Cancel</button>
                                {
                                    load ?
                                        <button type="button" className="address-save" disabled={load}>Loading...</button> :
                                        <button type="submit" className="address-save">Save</button>

                                }

                            </div>
                        </form>
                    </div>
                </div>
            )}


            {isChangeOpen && (
                <div className="address-overlay">
                    <div className="address-content address-change-options">
                        <h3>Select Address</h3>
                        {addressmain.map((address, index) => (
                            <label key={index} className={`address-option-modal ${selectedAddress?.id === address.id ? 'selected' : ''}`}>
                                <input
                                    type="radio"
                                    name="address"
                                    value={address.new_address}
                                    checked={selectedAddress?.id === address.id}
                                    onChange={() => setSelectedAddress(address)}
                                    className="hidden-radio"
                                />
                                <div>
                                    <strong>{address.location_user}</strong><br />
                                    {address.new_address}, {address.city} - {address.pincode}
                                </div>
                            </label>
                        ))}

                        <div className="address-modal-actions">
                            <button onClick={closeChangeModal} className="address-close">Cancel</button>
                            <button onClick={saveAddressChange} className="address-save">Save</button>
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}

export default Address;